














































































import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'

export default defineClassComponent(
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()
      // 商品活动数据
      commodityActivityData = computed(
        () => this.goodsData.value.commodityActivityData,
      )
      discountAfterMinAmt = computed(
        () => this.commodityActivityData.value.discountAfterMinAmt,
      )
    },
)
